<template>
	<div class="home">
		<vue-particles class="login-background" color="#97D0F2" :particleOpacity="0.7" :particlesNumber="50"
			shapeType="circle" :particleSize="4" linesColor="#97D0F2" :linesWidth="1" :lineLinked="true"
			:lineOpacity="0.4" :linesDistance="150" :moveSpeed="3" :hoverEffect="true" hoverMode="grab"
			:clickEffect="true" clickMode="push">
		</vue-particles>

		<div class="login-other">
			<el-form :rules="rules" class="loginContainer">
				<H3 class="loginTitle">微信授权管理端</H3>
				<el-form-item>
					<el-input prefix-icon="el-icon-user-solid" size="normal" type="text" v-model="phone"
						auto-complete="off" placeholder="请输入电话号码"></el-input>
				</el-form-item>

				<el-form-item v-if="showAdim">
					<div style="display: flex; justify-content: space-between">
						<el-select v-model="name" placeholder="请选择" @change="selectAdimn">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</el-form-item>



				<el-form-item>
					<div style="display: flex; justify-content: space-between">
						<el-input prefix-icon="el-icon-circle-check" style="width: 50%" type="text" v-model="code"
							auto-complete="off" placeholder="请输入验证码" @keydown.enter.native="denglu">
						</el-input>
						<el-button v-if="disabled" type="primary" style="width: 40%" @click="getYz">获取验证码</el-button>
						<el-button v-if="!disabled" type="info" disabled size="mini"
							style="magin-left: 3px">{{ timer }}秒后重试</el-button>
					</div>
				</el-form-item>
				<el-button size="medium" type="primary" style="width: 100%; height: 35px" @click="denglu">登录</el-button>
			</el-form>
		</div>

		<div class="footer"></div>
	</div>
</template>

<script>
	import lg from '../api/login/login.js'
	export default {
		name: "login",
		data() {
			return {
				ztdm: "",
				code: "",
				disabled: true,
				timer: 60,
				ztid: null,
				phone: "",
				rules: {
					ztdm: [{
						required: true,
						message: "请输入用户名",
						trigger: "blur"
					}],

					code: [{
						required: true,
						message: "请输入验证码",
						trigger: "blur"
					}],
				},
				options: [],
				name: "",
				showAdim: false,
			};
		},
		methods: {
			isadmin() {
				if (this.ztdm == "admin") {
					this.showAdim = true;
				} else {
					this.showAdim = false;
				}
			},
			async denglu() {

				let res = await lg.yzmdl(this.phone, this.code, 1)
				if (res.data.code == 1) {
					sessionStorage.setItem("token", res.data.data.token);
					sessionStorage.setItem("ztid", JSON.stringify(res.data.data.ztid));
					sessionStorage.setItem("dm", this.ztdm);
					sessionStorage.setItem("fsmm", res.data.data.fssm);
					sessionStorage.setItem("phone", res.data.data.phone);
					this.$router.push({
						name: "index"
					});
				} else {
					this.$message({
						message: res.data.msg,
						type: 'warning'
					});
					this.code = ''
				}

			},
			async yanzheng() {
				//获取验证码
				console.log(111);
				let data = this.ztdm;
				//console.log(data)
				let res = await lg.getztxx(data)
				console.log(res);
				if (res.data.code == 1) {
					sessionStorage.setItem("dqsj", res.data.data.dqsj);
					this.phone = res.data.data.phone;
					this.ztid = res.data.data.id;
					this.options = [];
					res.data.data.adminList.forEach((element) => {
						let obj = {
							label: element.username,
							value: element.phone,
						};
						this.options.push(obj);
					});
					// this.getYz();
				} else {
					this.$confirm(res.data.msg, "提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						})
						.then(() => {})
						.catch(() => {});
				}

			},
			selectAdimn(e) {
				this.phone = e;
			},
			isValidPhoneNumber(phoneNumber) {
				// 定义一个正则表达式来匹配常见的电话号码格式
				const phoneRegex = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;

				// 使用正则表达式测试输入的电话号码
				return phoneRegex.test(phoneNumber);
			},
			async getYz() {
				console.log(this.phone);
				if (!this.isValidPhoneNumber(this.phone)) {
					this.$message({
						message: "无效的手机号",
						type: "error",
					});
					return
				}

				let res1 = await lg.getyzm(this.phone)
				if (res1.data.code == 1) {
					this.$message({
						message: res1.data.msg,
						type: "success",
					});
					this.disabled = false;
					const authTimer = setInterval(() => {
						this.timer--;
						if (this.timer <= 0) {
							this.disabled = true;
							this.timer = 60;
							clearInterval(authTimer);
						}
					}, 1000);
				} else {
					this.$confirm(res1.data.msg, "提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						})
						.then(() => {})
						.catch(() => {});
				}

			},

		},

	};
</script>

<style sass scoped>
	.login-background {
		background: linear-gradient(-180deg, #dcf2e6 0%, #ffffff 100%);
		width: 100%;
		height: 100%;
		/**宽高100%是为了图片铺满屏幕 */
		z-index: -1;
		position: absolute;
	}

	.login-other {
		z-index: 1;
		margin: 180px 0 0 calc(calc(100vw - 410px) / 2);
		position: absolute;
	}

	.loginContainer {
		border-radius: 15px;
		background-clip: padding-box;
		width: 350px;
		padding: 15px 35px 15px 35px;
		background: #fefefe;
		border: 1px solid #eaeaea;
		box-shadow: 0 0 25px #cac6c6;
	}

	.loginTitle {
		margin: 15px auto 20px auto;
		text-align: center;
		color: #707070;
	}

	.loginRemember {
		text-align: left;
		margin: 0 0 15px 0;
	}

	el-form-item {
		margin: 10px;
	}
</style>